import React, { useState } from "react";
import "./index.css";

const faqs = [
  {
    question: "What is the venue for OxfordMUN India 2025?",
    answer: "FLAME University, Pune, India",
  },
  {
    question: "What are the dates for the OxfordMUN India  2025?",
    answer: "4th – 6th August, 2025",
  },
  {
    question: "How can I register for OxfordMUN India 2025?",
    answer: (<p>Visit <a href='https://forms.gle/iGD6K3SCNNK8SGYb6' target="_blank">Link</a> to secure your spot and embark on an unforgettable journey of Discovery, Diplomacy and Development.</p>),
  },
  {
    question: "What is the participation fee for OxfordMUN India 2025?",
    answer: (
      <ul>
        <li>
          <strong>School Registration Fee:</strong> INR 5,000 (Includes one
          teacher representative without any additional charge)
        </li>
        <li>
          <strong>Delegate Fee for MU20 School of Opportunity, BSAI and AFS Member Schools:</strong>[Phase 1] INR 30,000 (incl. of GST) [Phase 2] INR 35,000 (incl. of GST)
        </li>
        <li>
          <strong>Delegate Fee for Non-Member Schools:</strong> [Phase 1] INR 35,000 (incl. of GST) [Phase 2] INR 40,000 (incl. of GST)
        </li>
      </ul>
    ),
  },
  {
    question: "Who can participate in OxfordMUN India 2025?",
    answer: "Students from Grade 9th to 12th",
  },
  {
    question: "Will accommodation be provided to the participants?",
    answer: "Yes, the participants and their teacher coordinators would be provided with twin-sharing rooms at FLAME University, Pune.",
  },
  {
    question: "How can I get to the venue from the airport/ train station?",
    answer: "Convenient pickup and drop-off services from local station and airport would be provided to participants.",
  },
  {
    question: "Who can I contact for more information or assistance?",
    answer: (
      <ul>
        <li>
          <strong>Akshat Moghe: </strong> <span>+91-9522350555 connect@mu20.co</span>
        </li>
        <li>
          <strong>Madhur Oza: </strong> <span>+91-79875 19367 madhur.oza@mu20.co</span>
        </li>
      </ul>
    ),
  },
];

export default function FaqSection() {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggle = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };

  return (
    <section className="faq-section">
      <h2 className="faq-title">FREQUENTLY ASKED QUESTIONS</h2>
      <div className="faq-items">
        {faqs.map((faq, index) => (
          <div
            className={`faq-card ${activeIndex === index ? "active" : ""}`}
            key={index}
          >
            <button className="faq-question" onClick={() => toggle(index)}>
              <span>{faq.question}</span>
              <span className="faq-icon">
                 <img src={`/assets/images/OxfordMunNew/${activeIndex === index ? "arrow-dropdown-up.svg" : "arrow-dropdown-down.svg" }`} alt="arrow"/> 
              </span>
            </button>
            {activeIndex === index && (
              <div className="faq-answer">{faq.answer}</div>
            )}
          </div>
        ))}
      </div>
    </section>
  );
}
